import { BIOME_NUTRITION } from 'constants/textBunchesNames'
import withLocalization from 'containers/withLocalization'

import Component from './BiomeNutrition'

export default withLocalization(Component, BIOME_NUTRITION)
